// extracted by mini-css-extract-plugin
export default {"root":"ButtonSendForm_root__Z1yHq"};